import { Mapper } from "../../../../base/utils/mapper";

import { TypeMimeModel }
from "../../../../domain/models/academy/type-mime.model";

import { TypeMimeEntity }
from "../entities/type-mime.entity";

export class TypeMimeImplementationRepositoryMapper
extends Mapper<
TypeMimeEntity,
TypeMimeModel
> {

    mapFrom(param:
    TypeMimeEntity):
    TypeMimeModel {

        return {
            ...param
        };
    }

    mapTo(param:
    TypeMimeModel):
    TypeMimeEntity {

        return {
            ...param
        };
    }
}